export default __webpack_public_path__ + "0ce27e9eafd2d86d0b0089a260e2da2f.png";